export default __webpack_public_path__ + "static/estimator-cat-b38f6aa93ad30f698bb379d8e27465ba.svg";